/**
 * Builds the trigger flow inputs map based on the flow parameters and the
 * trigger configuration.
 *
 * @param {Object} parameter - The flow's parameter from its spec.
 * @param {Object} requestSchema - The trigger's requestSchema if it had one in
 *   its configuration.
 *
 * @returns {Object} The structure needed for the flow-trigger's flowInputsMap.
 */
export function buildFlowInputsMap(parameter, requestSchema) {
	const flowInputsMap = {};

	for (const prop in parameter.properties) {
		if (prop === 'config') {
			flowInputsMap.config = '$.config';
		} else if (prop === 'env') {
			flowInputsMap.env = '$.env';
		} else if (requestSchema && prop === 'request') {
			flowInputsMap.request = '$.request';
		}
	}

	return flowInputsMap;
}

/**
 * Builds a list of triggers parameters based on the trigger configuration and
 * what has been provided in the query.
 *
 * @param {Object} triggerParameters - The trigger parameters from the definition.
 * @param {Object} query - The query parameters passed in to the flow creation.
 *
 * @returns {Object} The whitelisted set of parameters that can be attached to
 *   the flow-trigger.
 */
export function buildTriggerParameters(triggerParameters, query) {
	const parameters = {};

	const configParams = triggerParameters.properties || {};
	Object.keys(configParams).forEach(param => {
		// If there is a trigger parameter in the query, add it
		if (query.hasOwnProperty(param)) {
			parameters[param] = query[param];
		}
	});

	return parameters;
}

/**
 * Helper function that returns the message required to hide the trigger ID in
 * the UI for all new flow-triggers.
 *
 * @returns {String} The new trigger status message.
 */
export function getNewTriggerStatusMessage() {
	return 'This flow-trigger is new and has not been saved yet.';
}
